import React from 'react';
import {canManageAssetViews} from '../../enablers/canManageAssetViews';
import {useAssetViewsProvider} from '../../contexts';
import {AssetViewsTable, type AssetViewsTableProps} from './AssetViewsTable';

export type AssetViewsTableContainerProps = Omit<
	AssetViewsTableProps,
	| 'asset'
	| 'data'
	| 'error'
	| 'filtered'
	| 'isItemLoaded'
	| 'loadMoreItems'
	| 'noMatches'
	| 'noRecords'
	| 'setSort'
	| 'sort'
	| 'totalRows'
>;

/**
 * `AssetViewsTableContainer` manages data fetching, state, and UI logic for displaying a table of system groups, abstracting complexity from `AssetViewsTable`.
 */

export const AssetViewsTableContainer = ({
	loading: _loading,
	...props
}: AssetViewsTableContainerProps) => {
	const {
		asset,
		data,
		dataReady,
		loading,
		error,
		filtered,
		noMatches,
		noRecords,
		sort,
		total,
		createView,
		setSort,
		openView,
	} = useAssetViewsProvider();

	const _showLoading = _loading || !asset || !dataReady;

	return (
		<AssetViewsTable
			{...props}
			asset={asset}
			dataReady={!_showLoading}
			loading={loading || _showLoading}
			data={_showLoading ? [] : data}
			error={error as any}
			filtered={filtered}
			noMatches={!_showLoading && noMatches}
			noRecords={!_showLoading && noRecords}
			sort={sort}
			totalRows={!_showLoading ? total : 10}
			onAdd={canManageAssetViews(asset) ? () => createView() : undefined}
			setSort={setSort}
			onRowClick={(row) => {
				openView(row.original.viewId);
			}}
		/>
	);
};

export default AssetViewsTableContainer;
